import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import { find, first } from "lodash-es";
import { maintenance } from "src/app/support/maintenance";
import { UserBackend } from "../backend/api/user.backend";
import { Member } from "../backend/models/member/member";
import { RouterData } from "../components/ui/router/router-data";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";
import { ErrorCodes } from "../modules/maintenance/error-codes";

@Injectable()
export class RoleGuard {
  constructor(
    private router: Router,
    private bootstrapService: BootstrapService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const data = this.getTargetRouterData(route);

    if (
      !data?.roles ||
      (!data.roles.authorized && !data.roles.unauthorized) ||
      ((data.roles.authorized || []).length === 0 &&
        (data.roles.unauthorized || []).length === 0)
    ) {
      console.log("[RoleGuard] route no roles");
      return true;
    }

    console.log(
      `[RoleGuard] route authorized roles: ${(data.roles.authorized || []).join(
        ","
      )}, unauthorized roles: ${(data.roles.unauthorized || []).join(",")}`
    );

    const member: Member = this.bootstrapService.getCurrentMember()!;

    if (!member || !member.roles || member.roles.length === 0) {
      this.unauthorized();
      return false;
    }

    if (data.roles.unauthorized) {
      const hasMatchingUnauthorizedRole = find(member.roles, (role) => {
        return data.roles!.unauthorized!.includes(role.type);
      });

      if (hasMatchingUnauthorizedRole) {
        console.log(`[RoleGuard] route unauthorized`);
        this.unauthorized();
        return false;
      }
    }

    if (data.roles.authorized) {
      const hasMatchingAuthorizedRole = find(member.roles, (role) => {
        return data.roles!.authorized!.includes(role.type);
      });

      if (!hasMatchingAuthorizedRole) {
        console.log(`[RoleGuard] route unauthorized`);
        this.unauthorized();
        return false;
      }
    }

    console.log(`[RoleGuard] route authorized`);
    return true;
  }

  private unauthorized(): void {
    maintenance(this.router, { code: ErrorCodes.ERR_004 });
  }

  private getTargetRouterData(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    parentRouterData: RouterData | null = null
  ): RouterData | null {
    const routerData: RouterData | null = activatedRouteSnapshot.data;

    if (
      activatedRouteSnapshot.children &&
      activatedRouteSnapshot.children.length > 0
    ) {
      return this.getTargetRouterData(
        first(activatedRouteSnapshot.children)!,
        routerData && routerData.roles ? routerData : parentRouterData
      );
    }
    return routerData && routerData.roles ? routerData : parentRouterData;
  }
}
